export default __webpack_public_path__ + "static/media/colab2.b91d4ace.png";